import { combineReducers } from '@reduxjs/toolkit';
import { brakesState } from './brakesState';
import { engineState } from './engineState';
import { interiorState } from './interiorState';
import { suspensionState } from './suspensionState';
import { transmissionState } from './transmissionState';

export default combineReducers({
    brakesState,
    engineState,
    interiorState,
    suspensionState,
    transmissionState,
});
